var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstaTabsSwitcher(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9817_14821)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.66882 2.87531C-0.264956 5.92264 0.335488 9.15976 0.335488 18.994C0.335488 27.1606 -1.0894 35.3475 6.36793 37.2749C8.6966 37.8738 29.3295 37.8738 31.655 37.2718C34.7599 36.4706 37.2861 33.9522 37.6315 29.5609C37.6797 28.948 37.6797 9.05087 37.6299 8.42553C37.2628 3.74798 34.3835 1.0522 30.5895 0.506199C29.7199 0.380199 29.5457 0.342865 25.0844 0.335087C9.25971 0.342865 5.79082 -0.361802 2.66882 2.87531Z",
    fill: "url(#paint0_linear_9817_14821)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.997 5.2174C13.3488 5.2174 7.98526 4.71496 5.93659 9.97274C5.09037 12.1443 5.21326 14.9645 5.21326 19.0027C5.21326 22.5463 5.0997 25.8767 5.93659 28.0312C7.98059 33.2921 13.3877 32.7881 18.9939 32.7881C24.4026 32.7881 29.9793 33.3512 32.0528 28.0312C32.9006 25.8378 32.7761 23.0596 32.7761 19.0027C32.7761 13.6174 33.0733 10.1407 30.4615 7.53052C27.817 4.88607 24.2408 5.2174 18.9908 5.2174H18.997ZM17.7619 7.70163C29.5437 7.68296 31.0433 6.37318 30.2157 24.5685C29.9217 31.0038 25.0217 30.2976 18.9986 30.2976C8.01637 30.2976 7.70059 29.9834 7.70059 18.9965C7.70059 7.88207 8.5717 7.70785 17.7619 7.69852V7.70163ZM26.3548 9.98985C25.4417 9.98985 24.7013 10.7303 24.7013 11.6434C24.7013 12.5565 25.4417 13.297 26.3548 13.297C27.2679 13.297 28.0084 12.5565 28.0084 11.6434C28.0084 10.7303 27.2679 9.98985 26.3548 9.98985ZM18.997 11.9234C15.0879 11.9234 11.9193 15.0936 11.9193 19.0027C11.9193 22.9118 15.0879 26.0805 18.997 26.0805C22.9061 26.0805 26.0733 22.9118 26.0733 19.0027C26.0733 15.0936 22.9061 11.9234 18.997 11.9234ZM18.997 14.4076C25.0715 14.4076 25.0793 23.5978 18.997 23.5978C12.9241 23.5978 12.9148 14.4076 18.997 14.4076Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9817_14821",
    x1: 2.74041,
    y1: 35.2839,
    x2: 37.4378,
    y2: 5.25373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDD55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF543E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C837AB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9817_14821"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37.3333,
    height: 37.3333,
    fill: "white",
    transform: "translate(0.332031 0.333984)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstaTabsSwitcher);
export default __webpack_public_path__ + "static/media/insta_tabs_switcher.0c675972ced79c2bd037e8047bb28890.svg";
export { ForwardRef as ReactComponent };